const PRESENTATION_FIELDS = `
  __typename
  ... on Presentation {
    id
    tenant_id
    exhibitor_id
    responsible_chair_id
    meeting_id
    group_id
    meeting_date
    suggested_topic_id
    exhibitor_comments
    materials_url
    administrative_status
    invoice_number
    per_diem_amount
    transport_amount
    travel_bonus_amount
    expense_receipts_url
    cancellation_reason
    status_change_comment
    its
    uts
    dts
    created_by
    updated_by
    deleted_by
    exhibitor {
      id
      contact {
        id
        firstname
        lastname
      }
    }
    chair {
      id
      contact {
        id
        firstname
        lastname
      }
    }
    topic {
      id
      title
    }
    meeting {
      id
      pay
      extra_pay
      expenses
      pay_mode
      exhibitor {
        pay
        pay_virtual
        pay_virtual_short
      }
      group {
        id
        name
        program {
          id
          name
          province {
            id
            name
            interior
          }
        }
      }
    }
  }
  ... on ResultError {
    status_code
    message
  }
`;

export const CREATE_PRESENTATION = `mutation CreatePresentation(
  $tenant_id: Int!,
  $input: CreatePresentationInput!
) {
  createPresentation(
    tenant_id: $tenant_id,
    input: $input
  ) {
    ${PRESENTATION_FIELDS}
  }
}`;

export const UPDATE_PRESENTATION = `mutation UpdatePresentation(
  $tenant_id: Int!,
  $input: UpdatePresentationInput!
) {
  updatePresentation(
    tenant_id: $tenant_id,
    input: $input
  ) {
    ${PRESENTATION_FIELDS}
  }
}`;

export const DELETE_PRESENTATION = `mutation DeletePresentation(
  $tenant_id: Int!,
  $id: Int!
) {
  deletePresentation(
    tenant_id: $tenant_id,
    id: $id
  ) {
    ${PRESENTATION_FIELDS}
  }
}`;

export const SUBMIT_PRESENTATION = `mutation SubmitPresentation(
  $tenant_id: Int!,
  $id: Int!,
  $group_id: Int!,
  $meeting_date: String!
) {
  submitPresentation(
    tenant_id: $tenant_id,
    id: $id,
    group_id: $group_id,
    meeting_date: $meeting_date
  ) {
    ${PRESENTATION_FIELDS}
  }
}`;

export const CANCEL_PRESENTATION = `mutation CancelPresentation(
  $tenant_id: Int!,
  $id: Int!,
  $reason: String!
) {
  cancelPresentation(
    tenant_id: $tenant_id,
    id: $id,
    reason: $reason
  ) {
    ${PRESENTATION_FIELDS}
  }
}`;

export const LOAD_PRESENTATION_RECEIPTS = `mutation LoadPresentationReceipts(
  $tenant_id: Int!,
  $id: Int!,
  $receipts_url: String!
) {
  loadPresentationReceipts(
    tenant_id: $tenant_id,
    id: $id,
    receipts_url: $receipts_url
  ) {
    ${PRESENTATION_FIELDS}
  }
}`;

export const ROLLBACK_PRESENTATION_BILLING = `mutation RollbackPresentationBilling(
  $tenant_id: Int!,
  $id: Int!
) {
  rollbackPresentationBilling(
    tenant_id: $tenant_id,
    id: $id
  ) {
    ${PRESENTATION_FIELDS}
  }
}`;

export const REGISTER_PRESENTATION_CLOSE = `mutation RegisterPresentationClose(
  $tenant_id: Int!,
  $id: Int!
) {
  registerPresentationClose(
    tenant_id: $tenant_id,
    id: $id
  ) {
    ${PRESENTATION_FIELDS}
  }
}`;

export const UPLOAD_PRESENTATION_INVOICE_FILE = `mutation UploadPresentationInvoiceFile(
  $tenant_id: Int!,
  $id: Int!,
  $invoice_amount: Float!,
  $file: Upload!
) {
  uploadPresentationInvoiceFile(
    tenant_id: $tenant_id,
    id: $id,
    invoice_amount: $invoice_amount,
    file: $file
  ) {
    ${PRESENTATION_FIELDS}
  }
}`;

export const UPLOAD_PRESENTATION_VIATICOS_FILE = `mutation UploadPresentationViaticosFile(
  $tenant_id: Int!,
  $id: Int!,
  $per_diem_amount: Float!,
  $file: Upload!
) {
  uploadPresentationViaticosFile(
    tenant_id: $tenant_id,
    id: $id,
    per_diem_amount: $per_diem_amount,
    file: $file
  ) {
    ${PRESENTATION_FIELDS}
  }
}`;

export const UPLOAD_PRESENTATION_EXPENSE_FILE = `mutation UploadPresentationExpenseFile(
  $tenant_id: Int!,
  $id: Int!,
  $total_expenses: Float!,
  $file: Upload!
) {
  uploadPresentationExpenseFile(
    tenant_id: $tenant_id,
    id: $id,
    total_expenses: $total_expenses,
    file: $file
  ) {
    ${PRESENTATION_FIELDS}
  }
}`;

export const CHANGE_PRESENTATION_STATUS = `mutation ChangePresentationStatus(
  $tenant_id: Int!,
  $id: Int!,
  $status: PresentationStatus!,
  $comment: String
) {
  changePresentationStatus(
    tenant_id: $tenant_id,
    id: $id,
    status: $status,
    comment: $comment
  ) {
    ${PRESENTATION_FIELDS}
  }
}`;

export const SEND_PRESENTATION_INVOICE_DOCUMENTATION = `mutation SendPresentationInvoiceDocumentation(
  $tenant_id: Int!,
  $id: Int!,
  $invoice_amount: Float!,
  $file: Upload,
  $per_diem_amount: Float,
  $viaticos_file: Upload,
  $receipt_file: Upload
) {
  sendPresentationInvoiceDocumentation(
    tenant_id: $tenant_id,
    id: $id,
    invoice_amount: $invoice_amount,
    file: $file,
    per_diem_amount: $per_diem_amount,
    viaticos_file: $viaticos_file,
    receipt_file: $receipt_file
  ) {
    ${PRESENTATION_FIELDS}
  }
}`;
